module.exports = __webpack_public_path__ + "static/media/bai_bg.52423cd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/bai_bg.png
// module id = 1465
// module chunks = 0